import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './index.css';
import 'App.css';
import 'styles/awl-custom.css';
import 'styles/global.css';
import 'styles/global-variables.css';
import 'styles/custom-radio.css';
import '@fullcalendar/react/dist/vdom';
import 'styles/zen-theme.css';
import 'styles/datePicker.css';
import 'styles/darkMode.css';
import 'styles/sideMenu.css';
// import 'ESS/Attendance/SHIFT/custom-calendar.css';
import App from './App';

//eslint-disable-next-line no-console
console.log(`${process.env.__APP_NAME__} ${process.env.__APP_VERSION__}`);
try {
  const buildTimestamp = document.head.dataset.buildTimestampUtc;
  //eslint-disable-next-line no-console
  console.log(
    `Released at around ${
      buildTimestamp ? new Date(buildTimestamp) : 'not available'
    }`,
  );
} catch (e) {
  console.error(e);
}

if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log(process.env.NODE_ENV);
  const origConsoleError = console.error;
  console.error = (...args) => {
    origConsoleError(...args);
    // eslint-disable-next-line no-console
    console.log(...args); //todo:call a fetch api
    // console.error(...args)
  };
}
ReactDOM.render(<App />, document.getElementById('root'));

window.addEventListener(
  'scroll',
  (e) => {
    // [
    //   ...document.getElementsByClassName('popover'),
    //   ...document.getElementsByClassName('dropdown-menu'),
    // ].forEach((el) => {
    //   if (!el.contains(e.target)) {
    //     document.body.click(); //close popovers
    //   }
    // });

    // //popovers and dropdown-menu both will have .show while visible
    // [...document.getElementsByClassName('show')].forEach((el) => {
    //   if (!el.contains(e.target)) {
    //     document.body.click(); //close popovers
    //   }
    // });

    // if (
    //   [
    //     '.popover.show',
    //     '.dropdown-menu.show',
    //     '.options-list',
    //     '#custom-select-container',
    //     '.rdw-dropdown-optionwrapper',
    //     '#tag-input-list',
    //     '.react-dropdown-select-dropdown',
    //   ].every(sel=>!e.target.closest(sel))
    // ) {
    //   document.body.click(); //close popoivers
    // }

    function isWithInParentBounds(el) {
      if (!el) return true;
      const scrollableContainer =
        el.closest('.awl-custom-scroll') ||
        el.closest('.awl-custom-table tbody'); //todo: determine with while loop and parent.offsetHeight > parent.clientHeight
      if (!scrollableContainer) return true;
      const rect = el.getBoundingClientRect();
      const containerRect = scrollableContainer.getBoundingClientRect();

      if (
        rect.top < containerRect.top ||
        rect.right > containerRect.right ||
        rect.bottom > containerRect.bottom ||
        rect.left < containerRect.left
      ) {
        return false;
      }

      return true;
    }

    window.isWithInParentBounds = isWithInParentBounds;

    //scroll containers, so close only if e.target is outside these elements
    if (
      ['.popover.show', '.rdw-dropdown-optionwrapper'].some(
        //'.options-list'
        (sel) => {
          // '.react-dropdown-select-dropdown'
          const targetEl = document.querySelector(sel);
          return (
            targetEl && !targetEl.contains(e.target) && e.target !== targetEl
          );
        },
      )
    ) {
      document.body.click();
      document.querySelector('.show.popover')?.classList?.remove('show');
    }

    //just popups in react-portal, so close them on scroll
    if (
      !isWithInParentBounds(document.querySelector('.dropdown-menu.show')) &&
      !document.querySelector('.dropdown-menu.show').contains(e.target)
    ) {
      document.body.click();
    }
    if (e.target.className) {
      if (
        e.target.className.includes('apply-job-dynamic-questions') ||
        e.target.className.includes('qualification-model')
      ) {
        manualClose();
      }
    }
  },
  {capture: true},
);

function manualClose() {
  document.body.click();
  if (
    document.getElementsByClassName('react-datepicker') &&
    document.getElementsByClassName('react-datepicker')?.length
  ) {
    document.getElementsByClassName('react-datepicker')[0].style.display =
      'none';
  }
}

function toggleZenMode() {
  document.body.classList.toggle('zen-theme');
}

const zenBtn = document.getElementById('zen-theme-btn');
zenBtn.addEventListener('click', toggleZenMode);
zenBtn.style.display = '';
window.toggleZenMode = toggleZenMode;

/**
 * showing tooltip for table cells with ellipsis
 */
// const tooltipsList = new Set();

const tooltip = document.createElement('div');
tooltip.classList.add('ellipsis-tooltip');
tooltip.style.position = 'fixed';

document.body.appendChild(tooltip);
let currentTarget = null;

// tooltip.addEventListener('transitionend', (e) => {
//   if (getComputedStyle(tooltip).opacity === '0') {
//     currentTarget = null;
//   }
// });
// && e.target.classList.contains('ellipsis-wrapper')
const condition = (e) =>
  ((e.target.tagName === 'TD' ||
    e.target.tagName === 'BUTTON' ||
    e.target.tagName === 'A') &&
    e.target.childNodes.length === 1) ||
  (e.target.classList.contains('ellipsis-wrapper') &&
    e.target.childNodes.length === 1) ||
  e.target.parentElement.classList.contains('formatted-th');
document.body.addEventListener(
  'mouseover',
  (e) => {
    if (condition(e)) {
      if (
        e.target.offsetWidth < e.target.scrollWidth &&
        currentTarget !== e.target
      ) {
        // console.log(previousTarget)
        if (currentTarget) {
          //if the tooltip is already visible for some other element, only then move smoothly, otherwise just appear.
          tooltip.classList.add('with-move-transition');
        } else {
          tooltip.classList.remove('with-move-transition');
        }
        currentTarget = e.target;
        //=====
        if (!e.target.textContent) return; //no text, only icons/images
        tooltip.innerHTML = e.target.textContent;
        const {top, left, right, bottom} = e.target.getBoundingClientRect();
        tooltip.style.width = right - left + 'px';
        tooltip.style.transform = `translate(${left}px,${bottom}px)`;
        tooltip.classList.add('show');

        e.target.addEventListener(
          'mouseleave',
          () => {
            tooltip.classList.remove('show');
            currentTarget = null;
          },
          {once: true} /*important*/,
        );
        document.body.addEventListener(
          'click',
          () => {
            tooltip.classList.remove('show');
            currentTarget = null;
          },
          {
            once: true,
            capture: true /*<Link>tag might have e.stopPropagation(). So.*/,
          },
        );
      }
    }
  },
  {capture: true},
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();

//donot add this. it causes issue in mobile when keyboard is opened. add resize listeners to dropdowns and popovers instead.
// window.addEventListener('resize', (e) => {
//   document.body.click();
// });

window.addEventListener(
  'storage',
  function () {
    // this triggers if this.localStorage of  same domain, changes i.e on cleared due to logout in other tab, we want to logout in this tab too.
    if (!this.localStorage.getItem('awl_token')) {
      //this.window.location.origin === "crm-dev.ptw.com" && !this.localStorage.getItem('authToken')
      //logout
      window.location = `${
        process.env.REACT_APP_OPServer
      }/oxauth/restv1/end_session?post_logout_redirect_uri=${
        process.env.REACT_APP_redirectURL
      }&id_token_hint=${localStorage.getItem('id_token')}`;
    }
  },
  false,
);

window.TABLE_LIMIT = 15;
if (document.body.clientHeight > 1100) {
  //>1080
  window.TABLE_LIMIT = 30;
}

if (document.body.clientHeight > 1800) {
  //4k = 3840 X 2160 => document.body will be atleast a 200px less than the screen height.
  window.TABLE_LIMIT = 60;
}
document.body.addEventListener('scroll', (e) => {
  e.target.tagName === 'TBODY' && document.body.click();
});
